/*
 * Home Component - Grid-First Professional Layout
 */
import React, { useState, useCallback } from 'react';
import { Flex, ProgressCircle, Text } from '@adobe/react-spectrum';
import { useAuth } from '../context/AuthContext';
import { PrescriptionGrid } from './PrescriptionGrid';
import { PrescriptionUploadForm } from './PrescriptionUploadForm';
import { CustomerLogin } from './CustomerLogin';
import { PrescriptionEditForm } from './PrescriptionEditForm';

export const Home = (props) => {
  const { customerData, isAuthenticated, isValidating, login } = useAuth();
  const [refreshGrid, setRefreshGrid] = useState(null);
  const [showUploadForm, setShowUploadForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [selectedPrescription, setSelectedPrescription] = useState(null);

  // console.log('customerData in Home:', customerData);

  // console.log('Quote Id from HOme' , props.quoteId )
  // console.log('Quote SKUE from HOme' , props.quoteSkus )

  const handleLoginSuccess = (loggedInCustomerData) => {
    login(loggedInCustomerData);
  };

  const handleGridRefreshReady = useCallback((refreshFn) => {
    setRefreshGrid(() => refreshFn);
  }, []);

  const handleUploadClick = () => {
    setShowUploadForm(true);
  };

  const handleCancelUpload = () => {
    setShowUploadForm(false);
  };

  const handleUploadSuccess = (newPrescription) => {
    if (refreshGrid) {
      refreshGrid();
    }
    setShowUploadForm(false);
  };

  const handleEditClick = (prescription) => {
    setSelectedPrescription(prescription);
    setShowEditForm(true);
  };

  const handleCancelEdit = () => {
    setShowEditForm(false);
    setSelectedPrescription(null);
  };

  const handleEditSuccess = () => {
    if (refreshGrid) {
      refreshGrid();
    }
    setShowEditForm(false);
    setSelectedPrescription(null);
  };

  // console.log('ims on Home', props.ims);

  if (isValidating) {
    return (
      <Flex
        direction="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        gap="size-200"
      >
        <ProgressCircle aria-label="Validating authentication" isIndeterminate size="L" />
        <Text UNSAFE_style={{ fontSize: '16px', color: '#6e6e6e' }}>
          Validating authentication...
        </Text>
      </Flex>
    );
  }

  return (
    <Flex
      direction="column"
      minHeight="100vh"
      margin="size-25"
    >
      {!isAuthenticated ? (
        <CustomerLogin ims={props.ims} onLoginSuccess={handleLoginSuccess} />
      ) : (
        <>
          {showUploadForm ? (
            /* Show Upload Form */
            <PrescriptionUploadForm
              customerData={customerData}
              onSuccess={handleUploadSuccess}
              onCancel={handleCancelUpload}
              ims={props.ims}
              quoteId={props.quoteId}
              quoteSkus={props.quoteSkus}
            />
          ) : showEditForm ? (
            /* Show Edit Form */
            <PrescriptionEditForm
              prescription={selectedPrescription}
              customerData={customerData}
              onSuccess={handleEditSuccess}
              onCancel={handleCancelEdit}
              ims={props.ims}
            />
          ) : (
            /* Show Prescription Grid */
            <PrescriptionGrid
              customerData={customerData}
              onRefresh={handleGridRefreshReady}
              onUploadClick={handleUploadClick}
              onEditClick={handleEditClick}
              ims={props.ims}
            />
          )}
        </>
      )}
    </Flex>
  );
};